// TZ раздел 5.3 — валидация сеток коэффициентов: верхний бэнд «100 и более» и непересечение бэндов.
export const OPEN_BAND_TO = 1000000;

export const bandsOverlap = (from, to, list = [], excludeId = null) => {
  const fromNum = Number(from);
  const toNum = Number(to);
  return list.some((el) => {
    if (excludeId && el.sale_koef_id === excludeId) return false;
    const eFrom = Number(el.percents_from);
    const eTo = Number(el.percents_to);
    return fromNum < eTo && eFrom < toNum;
  });
};
